import { decorate, observable, action, computed } from 'mobx';
import EmailCriteriaDialog from './layouts/EmailCriteriaDialog';
import MapFieldsDialog from './layouts/MapFieldsDialog';
import SelectEmailDialog from './layouts/SelectEmailDialog';
import clone from 'lodash/cloneDeep';
import SelectEmailFrequency from './layouts/SelectEmailFrequency';
import ParsersListDialog from './layouts/ParsersListDialog';
import TestParserDialog from './layouts/TestParserDialog';
// import { useStaticRendering } from 'mobx-react';

// useStaticRendering(typeof window === 'undefined');
class EmailIntegrationsStore {
  constructor(appStore) {
    this.appStore = appStore;
  }
  oaut2ClientCredentialsData = {
    "microsoft": {
      // id: "microsoft",
      name: "Microsoft For Fetch Email",
      redirect_url: window.mainDomain + "/oauth/oauth_login_redirect.php",
      auth_url: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
      access_token_url: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
      client_id: "8e4adc7d-057d-4b52-9e02-71306a7ac0b9",
      scope: "Mail.Read User.Read offline_access",
      is_system: 1,
      is_system_account: 1,
      account_website: "microsoft",
    },
    "google": {
      // id: "microsoft",
      name: "Google For Fetch Email",
      redirect_url: window.mainDomain + "/oauth/oauth_login_redirect.php",
      auth_url: "https://accounts.google.com/o/oauth2/v2/auth",
      access_token_url: "https://www.googleapis.com/oauth2/v4/token",
      client_id: "866085713897-4ca9o7tjacak15aaqo30gg6is9iv9afa.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/userinfo.profile email",
      is_system: 1,
      is_system_account: 1,
      account_website: "google",
    }
  }

  // OBSERVABLES
  isDialogOpen = false
  isDialogRendered = false
  isDeleteButtonShown = false
  currentState = null
  currentTemplate = 0
  isLoading = false
  isSaveConfigApiLoading = false

  setOAuth2ClientDataRedirectUrl = () => {
    this.oaut2ClientCredentialsData["microsoft"]["redirect_url"] = this.appStore.configStore?.config?.site?.main_domain + "/oauth/oauth_login_redirect.php";
    this.oaut2ClientCredentialsData["google"]["redirect_url"] = this.appStore.configStore?.config?.site?.main_domain + "/oauth/oauth_login_redirect.php";
  }

  getDefaultData = () => {
    return {
      templates: [
        this.getDefaultTemplateData()
      ],
      units: 1,
      count: 5,
      authentication: {
        type: "oauth2",
        value: null
      },
      website: "",
      is_disabled: false,
    };
  }

  getDefaultTemplateData = () => {
    return {
      fields: [
        [],
      ],
      template: {
        html: "",
        text: ""
      },
      subject_template: {
        html: "",
        text: ""
      },
      template_selections: {},
      criteria: "",
      criteria_type: 2,
      is_disabled: false,
      multiple_rows_data: {
        type: "",
        data: {},
        options: {
          rowsPath: {},
          rowsPathString: ""
        }
      }
    };
  }
  currentData = this.getDefaultData();

  // ACTIONS  
  showSelectEmailDialog = () => {
    if (!this.isRendered) {
      this.renderDialogs();
    }
    this.isLoading = true;
    this.currentState = "email-type";
    window.TL.ApiClient.MailParser.getConfigs(
      {
        list_id: this.appStore.containerStore.listId
      }).then({
        success: (response) => {
          this.isLoading = false;
          if (!response.success) {
            console.log("api failed")
            return;
          }
          this.fetchEmailConfigs = response.data;

          if (response.data.length > 0) {
            this.currentData = response.data[0];
            this.currentDataCopy = response.data[0]
            // this.currentData['authentication'] = JSON.parse(this.currentData['authentication']);
            this.isDeleteButtonShown = true;
            this.showParsersListDialog();
            // this.showMapFieldsDialog();
          } else {
            this.currentState = "email-type";
            this.isDeleteButtonShown = false;
            this.currentData = this.getDefaultData();
          }
        }
      })
  }

  renderDialogs = () => {
    this.appStore.renderDialog(this, ParsersListDialog)
    this.appStore.renderDialog(this, SelectEmailFrequency)
    this.appStore.renderDialog(this, SelectEmailDialog)
    this.appStore.renderDialog(this, MapFieldsDialog)
    this.appStore.renderDialog(this, EmailCriteriaDialog)
    this.isRendered = true;
  }

  showParsersListDialog = () => {
    this.currentData = this.currentDataCopy;
    this.currentState = "parsers-list"
  }

  showEmailTypeDialog = () => {
    this.currentState = "email-type"
  }

  showEmailFrequencyDialog = () => {
    this.currentState = "email-frequency"
  }

  emailFrequencyDropDownList = [
    { name: "Every 5 Minutes", value: "every_5_min" },
    { name: "Every 10 Minutes", value: "every_10_min" },
    { name: "Hourly", value: "hourly" },
    { name: "Dialy", value: "daily" },
  ];

  getCurrentEmailFrequencyValue = () => {
    let me = this,
      value;
    if (me.currentData.units == 1 && me.currentData.count == 5) {
      value = "every_5_min";
    } else if (me.currentData.units == 1 && me.currentData.count == 10) {
      value = "every_10_min";
    } else if (me.currentData.units == 2 && me.currentData.count == 1) {
      value = "hourly";
    } else if (me.currentData.units == 3 && me.currentData.count == 1) {
      value = "daily";
    }

    return {
      value: value || "every_5_min"
    }
  }

  getCurrentEmailFrequencyLabel = () => {
    let me = this,
      value = me.getCurrentEmailFrequencyValue(),
      freq;

    freq = me.emailFrequencyDropDownList.find(obj => obj.value == value.value);
    return freq.name;
  }

  showMapFieldsDialog = () => {
    // this.currentTemplate = currentTemplate;
    this.currentState = "map-fields";
  }

  showEmailCriteriaDialog = () => {
    this.currentState = "email-criteria";
  }

  setMapFieldsData = (data) => {
    this.mapFieldsData = data;
  }

  handleDisable = (isDisabled) => {
    this.currentData.is_disabled = isDisabled;
    this.handleSave(false, `Email Fetch ${isDisabled ? "Disabled" : "Enabled"} Successfully`);
  }

  handleEditTemplate = (id) => {
    this.currentTemplate = id;
    this.showEmailCriteriaDialog();
  }

  handleAddTemplate = () => {
    this.currentData.templates = [...this.currentData.templates, this.getDefaultTemplateData()];
    this.currentTemplate = this.currentData.templates.length - 1;
    this.showEmailCriteriaDialog();
  }

  handleDeleteTemplate = (key) => {
    Ext.Msg.confirm('Alert', 'Are you sure?', (button) => {
      if (button === 'yes') {
        this.currentData.templates.splice(key, 1);
        this.handleSave(false, `Parser Deleted Successfully`);
      }
    });
  }

  handleClearErrors = (key) => {
    this.currentData.templates[key]['errors'] = [];
    this.handleSave(true, `Errors Cleared Successfully`);
  }

  handleChange = (value, key) => {
    this.currentData[key] = value;
  }

  handleCurrentTemplateChange = (value, key) => {
    this.currentData.templates[this.currentTemplate][key] = value;
  }

  disableTemplate = (isDisabled, templateId = this.currentTemplate) => {
    this.currentData.templates[templateId].is_disabled = isDisabled;
    this.handleSave(false, `Parser ${isDisabled ? "Disabled" : "Enabled"} Successfully`);
  }

  handleTemplateSelectionChange = (val, key) => {
    // this.currentData.templates[this.currentTemplate]["template_selections"] = this.currentData.templates[this.currentTemplate]["template_selections"] || {};
    let currentSelection = {};

    currentSelection[key] = val;
    this.currentData.templates[this.currentTemplate]["template_selections"] = {
      ...this.currentData.templates[this.currentTemplate]["template_selections"],
      ...currentSelection
    };
  }

  handleMultipleRowsColumnDataChange = (val, key) => {
    let currentSelection = {};

    currentSelection[key] = val;
    this.currentData.templates[this.currentTemplate]["multiple_rows_data"]['data'] = {
      ...this.currentData.templates[this.currentTemplate]["multiple_rows_data"]['data'],
      ...currentSelection
    };
  }

  handleMultipleRowsDataChange = (val, aliasPath) => {
    let data = clone(val);

    delete data['data'];
    this.currentData.templates[this.currentTemplate]["multiple_rows_data"] = { ...this.currentData.templates[this.currentTemplate]["multiple_rows_data"], ...data };

    this.handleMultipleRowsColumnDataChange(val['data'], aliasPath);
  }

  handleTestParserButtonClick = (parserId = null) => {
    this.appStore.renderDialogWithoutStore(TestParserDialog, {
      mailInboxAccountId: this.currentData.id,
      parserId: parserId,
      isFromShown: this.isCriteriaContains("EMAIL_FROM", parserId),
      isToShown: this.isCriteriaContains("EMAIL_TO", parserId)
    })
  }

  isCriteriaContains = (type = "EMAIL_FROM", parserId = null) => {
    let me = this,
      flag = false;

    me.currentData.templates.forEach((template, key) => {
      if (!parserId || parserId == key) {
        if (template.criteria.includes(type)) {
          flag = true;
        }
      }
    })

    return flag;
  }

  handleClose = (isAlertShown = true) => {
    if (!isAlertShown) {
      this.currentData = this.getDefaultData();
      this.currentState = "";
      return;
    }
    Ext.Msg.confirm('Alert', 'Are you sure?', (button) => {
      if (button === 'yes') {
        this.currentState = "";
      }
    });

  }

  handleSave = (showParsersListDialog = true, successMessage) => {
    let data = clone(this.currentData);

    successMessage = successMessage || "Parser added successfully! <br /> You can test if the newly added parser works correctly by clicking the 'Test Parser' button";

    data['templates'] = JSON.stringify(data['templates']);
    data['authentication'] = JSON.stringify(data['authentication']);
    data['list_id'] = this.appStore.containerStore.listId;
    this.isSaveConfigApiLoading = true;

    window.TL.ApiClient.MailParser.saveConfig(
      data
    ).then({
      success: (response) => {
        this.isSaveConfigApiLoading = false;
        if (!response.success) {
          Ext.Msg.alert('Error', response.messages);
          return;
        }

        this.currentData = response.data;
        this.currentDataCopy = response.data;
        Ext.Msg.alert('Success', successMessage);
        if (showParsersListDialog && this.currentState != "parsers-list") {
          this.showParsersListDialog();
          // this.handleClose(false);
        }
      }
    });
  }

  handleEmailTypeClick = (type) => {
    let data = this.oaut2ClientCredentialsData[type];

    data.type = "oauth2";
    this.currentData.website = type;

    if (this.currentData.authentication.value) {
      this.askUserConsentForApproval(data);
      return;
    }

    window.TL.ApiClient.AuthAccounts.addAccount(
      data
    ).then({
      success: (response) => {
        if (!response.success) {
          Ext.Msg.alert('Error', response.messages);
          return;
        }
        this.currentData.authentication.value = response.data;
        this.askUserConsentForApproval(data);
      }
    });
  }

  askUserConsentForApproval = (data) => {
    var win = window.open(data.auth_url
      + "?client_id=" + data.client_id
      + "&redirect_uri=" + data.redirect_url
      + "&scope=" + data.scope
      + "&response_type=" + "code"
      + "&state=" + JSON.stringify({
        url: this.appStore.configStore?.config?.site?.server_url + "/auth-accounts/oauth2-callback",
        accountId: this.currentData.authentication.value
      }) //todo make dynamic
      + "&access_type=" + "offline"
      + "&prompt=consent"
      , "oauth2_window");

    var timer = setInterval(() => {
      if (win.closed) {
        clearInterval(timer);
        this.verifyAuthAccountAndAddParser();
      }
    }, 1000);

  }

  verifyAuthAccountAndAddParser = () => {
    this.isLoading = true;
    window.TL.ApiClient.AuthAccounts.verifyAccount(
      {
        id: this.currentData.authentication.value
      }
    ).then({
      success: (response) => {
        this.isLoading = false;
        if (!response.success) {
          Ext.Msg.alert('Error', response.messages);
          return;
        }
        if (!response.data.is_valid) {
          Ext.Msg.alert('Error', "Account Not authorised.");
          return;
        }
        this.showEmailFrequencyDialog();
      }
    });
  }

  handleDelete = () => {
    Ext.Msg.confirm('Confirm?', 'Are you sure you want to delete the connected account?', (button) => {
      if (button === 'yes') {
        window.TL.ApiClient.MailParser.deleteConfig(
          {
            id: this.fetchEmailConfigs[0].id
          }).then({
            success: (response) => {
              if (!response.success) {
                Ext.Msg.alert('Error', response.messages);
                return;
              }
              this.showSelectEmailDialog();
            }
          })
      }
    });
  }

}

decorate(EmailIntegrationsStore, {
  isDialogOpen: observable,
  currentState: observable,
  currentData: observable,
  isLoading: observable,
  isSaveConfigApiLoading: observable,
  // createPack: action,
  showDialog: action,
});

export default EmailIntegrationsStore;